import type { FormApi } from '../../../form-hooks/useFormApi';
import type {
  ContentTypeDefinition,
  Media,
  WithOptionalInternalProps,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

export type PluginFormLock = {
  /** Names of the fields that should be disabled */
  fields?: string[];
  /** If saving the form should be blocked */
  submit?: boolean;
};

export type LockFormFn = (lock: PluginFormLock | null) => void;

export type ReloadContentObjectFn = () => Promise<Media | undefined>;

type MediaFormAddElementEventInit = {
  /** Media content type */
  contentType: WithOptionalInternalProps<ContentTypeDefinition>;
  /** Media being edited */
  contentObject: Media;
  /** Limited data from form */
  form: FormApi;
  /** If form is disabled */
  disabled: boolean;
  /** Locks fields and saving of the form, e.g. while a plugin fills it in. */
  lockForm: LockFormFn;
  /** Fetches the media again, e.g. after it was saved outside the form. */
  reloadContentObject: ReloadContentObjectFn;
};

/**
 * An event that renders an additional element in the media edit form,
 * between the file name and the title fields.
 *
 * @memberof FlotiqPlugins.Events
 * @eventName "flotiq.media.form::add"
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to add an element to the media form.
 */
export class MediaFormAddElementEvent extends IFlotiqPluginEvent {
  constructor(initData: MediaFormAddElementEventInit) {
    super(initData);
  }
}
